import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import PartyDashboard from '../PartyDashboard';
import PartyPageImpl from './PartyPageImpl';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function PartyPage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer({drawerOpen: true}));
    },[]);

    return (
        < PartyPageImpl />
    )

}